// modules
import { handleActions } from 'redux-actions'

// actions
import {
  setCompanyDashboardData,
  setCompanyDashboardActivitiesData,
  setCompanyDashboardAlertsPriorityCount
} from 'src/store/modules/dashboard/companyDashboard'

const initialState = {
  alertsPriorityCount: {},
  companyDashboardData: {},
  companyDashboardActivitiesData: []
}

export default handleActions(
  {
    [setCompanyDashboardAlertsPriorityCount](
      state,
      { payload: alertsPriorityCount }
    ) {
      return {
        ...state,
        alertsPriorityCount
      }
    },

    [setCompanyDashboardData](state, { payload: companyDashboardData }) {
      return {
        ...state,
        companyDashboardData
      }
    },

    [setCompanyDashboardActivitiesData](
      state,
      { payload: companyDashboardActivitiesData }
    ) {
      return {
        ...state,
        companyDashboardActivitiesData
      }
    }
  },
  initialState
)
